/**
 * The Clerk scripts the app loads, pinned to exact versions (#341).
 *
 * Unpinned, @clerk/react asks Clerk's CDN for @clerk/clerk-js@6 and @clerk/ui@1, and each answers with a 307 to the
 * current version: ~140 ms a hop cold, never cached, two per page load, in series with the script itself (speed audit
 * 2026-10-20). Pinned, there are no hops, and public/index.html preloads the two exact URLs while the HTML parses
 * instead of after main.js has run.
 *
 * BUMPED BY HAND. To move to a newer Clerk (with @clerk/react upgrades, say), read the versions the CDN's redirects
 * point at today, e.g. `curl -sI https://<FAPI host>/npm/@clerk/clerk-js@6/dist/clerk.browser.js | grep -i location`
 * (and @clerk/ui@1/dist/ui.browser.js), set them here, and change the preloads in public/index.html to match:
 * clerkScripts.test.ts fails until they do, since a preload that misses Clerk's URL by a byte downloads it twice.
 */
export const CLERK_JS_VERSION = "6.39.0";
export const CLERK_UI_VERSION = "1.40.0";

/**
 * The ClerkProvider props that pin them. They're internal props: @clerk/react passes them to @clerk/shared's
 * clerkJSScriptUrl / clerkUIScriptUrl (loadClerkJsScript), and its public ClerkProviderProps type omits them; the typed
 * InternalClerkProvider lives at @clerk/react/internal, which this tsconfig's moduleResolution can't import. So they
 * ride in as a spread.
 */
export const CLERK_SCRIPT_PINS = {
  __internal_clerkJSVersion: CLERK_JS_VERSION,
  __internal_clerkUIVersion: CLERK_UI_VERSION,
} as const;
